import { useState, useEffect } from 'react'

// Fetches the supported-currency catalog (GET /api/v1/currencies) once and
// exposes a code -> { symbol, exponent, description } lookup. Used by the
// payment form to render allocation amounts in the *selected* currency while
// all allocation math stays in the book's settlement currency.
//
// Falls back to an empty map on failure so the form degrades to settlement
// currency display rather than breaking.
const useCurrencies = (authState) => {
  const [byCode, setByCode] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    if (authState && authState.api) {
      authState.api.getCurrencies()
        .then((response) => {
          if (!active) { return }
          const list = (response.data && response.data.currencies) || []
          const map = {}
          list.forEach((c) => {
            map[c.name] = { symbol: c.symbol, exponent: c.exponent, description: c.description }
          })
          setByCode(map)
          setLoading(false)
        })
        .catch(() => {
          if (!active) { return }
          setLoading(false)
        })
    }
    return () => { active = false }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [authState])

  return { byCode, loading }
}

export default useCurrencies
